import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { AgentAccessGate } from '../../../pages/dashboard/agent/AgentAccessGate';
import { AgentWorkspace } from '../../../pages/dashboard/agent/AgentWorkspace';
import { readAgentAsk } from '../../../pages/dashboard/agent/agentAsk';

/** `ask` is a first message to send once; see `agentAsk.ts`. */
export interface AgentThreadSearch {
  ask?: string;
}

export const Route = createFileRoute('/dashboard/agent/$threadId')({
  validateSearch: (search: Record<string, unknown>): AgentThreadSearch => {
    const ask = readAgentAsk(search.ask);
    return ask === undefined ? {} : { ask };
  },
  component: AgentThreadRoute,
  staticData: { fullBleed: true },
});

function AgentThreadRoute() {
  const { threadId } = Route.useParams();
  const { ask } = Route.useSearch();
  const navigate = useNavigate();
  return (
    <AgentAccessGate>
      <AgentWorkspace
        threadId={threadId}
        initialAsk={ask}
        onInitialAskTaken={() => {
          void navigate({
            to: '/dashboard/agent/$threadId',
            params: { threadId },
            search: {},
            replace: true,
          });
        }}
      />
    </AgentAccessGate>
  );
}
